<!--suppress TypeScriptUnresolvedVariable -->
<div *ngIf="constructor.name.length > 1" class="component-name">>> {{constructor.name}} <<</div>

<form class="po-pdf">
    <div class="header">
        <div class="header-left">
            <div>{{headerLeftText1}}</div>
            <div>{{headerLeftText2}}</div>
            <div>{{headerLeftText3}}</div>
        </div>
        <div class="header-center">
            <div class="center-logo"><img src="/assets/images/west_virginia_state_police_logo.png" alt="logo"/></div>
            <div class="center-title">{{headerCenterTextTitle}}</div>
            <div class="center-info">{{headerCenterTextInfo}}</div>
        </div>
        <div class="header-right">
            <div class="header-right-content">{{headerRightText}}</div>
        </div>
    </div>

    <div class="intro">
        <div>{{introRegularText1}}</div>
        <div>{{introRegularText2}}</div>
        <div>{{introRegularText3}}</div>
        <div>{{introRegularText4}}</div>
    </div>

    <div class="po-info">
        <div>1.</div>
        <div class="po-info-section">
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(fullNameOfSellerText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.additionalData.sellerFullName" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(homeAddressText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.additionalData.homeAddress" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
            <div class="multiple-fields">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(sellersHomeCountyText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.additionalData.homeCountry" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="p-inputgroup zip">
                    <span>{{removeUnderscores(sellersHomeZipText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.additionalData.homeZip" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(sellersHomePhoneNumberText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.additionalData.homePhoneNumber" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
        </div>
    </div>

    <div class="po-info">
        <div>2.</div>
        <div class="po-info-section">
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(sellersBusinessAddressText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.additionalData.businessAddress" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
            <div class="multiple-fields">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(sellersBusinessCountyText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.additionalData.businessCountry" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="p-inputgroup zip">
                    <span>{{removeUnderscores(sellersBusinessZipText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.additionalData.businessZip" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(sellersBusinessPhoneNumberText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.additionalData.businessPhoneNumber" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
        </div>
    </div>

    <div class="po-info">
        <div style="padding-top: 0">3.</div>
        <div class="po-info-section">
            <div>{{descriptionForTransportText}}</div>
            <div class="seller-info">

                <div style="display: flex; flex-direction: row; align-items: center; gap: 8px;">
                    <p-dropdown [options]="poManager.current.vendor.contacts" [(ngModel)]="selectedContact" [ngModelOptions]="{standalone: true}" optionLabel="fullName" placeholder="Select Contact"
                            (onChange)="onSelectedContactChanged($event)"></p-dropdown>
                    <span style="color: red; font-size: .9rem" *ngIf="selectedContact != null && !contactValid">Contact data is incomplete</span>
                </div>
                <div class="fields">
                    <div>{{removeUnderscores(idText)}}: {{idNum}}</div>
                    <div>{{removeUnderscores(stateText)}}: {{idState}}</div>
                </div>
            </div>
            <div class="multiple-fields">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(makeText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.vehicleMake" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(modelText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.vehicleModel" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(licenseNumberText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.vehicleNumber" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="p-inputgroup state-of-issue">
                    <span>{{removeUnderscores(stateOfIssueText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.vehicleState" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
            <div class="field-group">
                <div class="p-inputgroup color">
                    <span>{{removeUnderscores(colorText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.vehicleColor" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
        </div>
    </div>

    <div class="po-info">
        <div>4.</div>
        <div class="po-info-section">
            <div class="multiple-fields">
                <!-- <div class="p-inputgroup">
                    <span>{{removeUnderscores(dateOfTransactionText)}}</span><input type="text" pInputText [(ngModel)]="dateOfTransaction" [ngModelOptions]="{standalone: true}"/>
                </div> -->
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(dateOfTransactionText)}}</span>
                    <p-calendar [(ngModel)]="poManager.current.purchaseDate" [showTime]="true" [ngModelOptions]="{standalone: true}" [styleClass]="ThemeManager.theme" appendTo="body" inputStyleClass="calendar-input-style"></p-calendar>
                </div>
                <!-- <div class="p-inputgroup">
                    <span>{{removeUnderscores(timeOfTransactionText)}}</span><input type="text" pInputText [(ngModel)]="timeOfTransaction" [ngModelOptions]="{standalone: true}" [disabled]="true"/>
                </div> -->
                <div class="p-inputgroup">
                    <span>Time Zone</span>
                    <p-dropdown [options]="timeZones" [(ngModel)]="selectedTimezone" [ngModelOptions]="{standalone: true}"
                        optionLabel="fullName" placeholder="Select Timezone"></p-dropdown>
                </div>
            </div>
        </div>
    </div>

    <div class="po-info">
        <div style="padding-top: 0">5.</div>
        <div class="po-info-section">
            <div>{{descriptionOfKindText}}</div>
            <div *ngFor="let description of poManager.current.additionalData.kindOfScrapMaterials; let index = index;" class="multiple-fields">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(purchasedText)}}</span><input type="text" pInputText [(ngModel)]="description.purchased" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(characterText)}}</span><input type="text" pInputText [(ngModel)]="description.character" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(weightText)}}</span><input type="text" pInputText [(ngModel)]="description.weight" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
        </div>
    </div>

    <div class="po-info">
        <div style="padding-top: 0">6.</div>
        <div class="po-info-section">
            <div class="multiple-fields">
                <div style="flex-shrink: 0">{{wasMetalText}}</div>
                <div class="p-inputgroup">
                    <p-checkbox [(ngModel)]="poManager.current.additionalData.scrapMaterialPurchased" [label]="purchasedOptionText" [binary]="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                </div>
                <div class="p-inputgroup">
                    <p-checkbox [(ngModel)]="poManager.current.additionalData.scrapMaterialCollateral" [label]="collateralOptionText" [binary]="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                </div>
                <div class="p-inputgroup">
                    <p-checkbox [(ngModel)]="poManager.current.additionalData.scrapMaterialConsignment" [label]="consignmentText" [binary]="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                </div>
            </div>
        </div>
    </div>

    <div class="po-info">
        <div style="padding-top: 0">7.</div>
        <div class="po-info-section" [innerHTML]="section7Text"></div>
    </div>

    <div class="payment-info">
        <div class="title">8.</div>
        <div class="pay-tab">
            <table>
                <tr>
                    <th *ngFor="let column of columns" [style.width]="column.widthPercent + '%'">{{column.title}}</th>
                </tr>
            <tr class="bordered-row">
                <td [style.width]="columns[0].widthPercent + '%'" [style.textAlign]="'center'" rowspan="2">{{poManager.current.number}}</td>
                <td [style.width]="columns[1].widthPercent + '%'" [style.textAlign]="'center'">Converters</td>
                <td [style.width]="columns[2].widthPercent + '%'" [style.textAlign]="'center'">{{poManager.current.totalNumConverters}}</td>
                <td [style.width]="columns[3].widthPercent + '%'" [style.textAlign]="'center'">{{poManager.current.totalConvertersPrice | currency:poManager.current.currency:true}}</td>
                <td [style.width]="columns[4].widthPercent + '%'" [style.whiteSpace]="'nowrap'" [style.textAlign]="'center'" rowspan="2">{{poManager.current.totalPrice | currency:poManager.current.currency:true}}</td>
                <td [style.width]="columns[5].widthPercent + '%'" [style.textAlign]="'center'" >                            
                    <p-inputNumber [inputStyle]="{'width': '100px', 'backgroundColor': 'white', 'border': '1px solid gray'}" [(ngModel)]="poManager.current.catsAdjustment" (ngModelChange)="poManager.adjustmentChange()" inputId="currency-us" mode="currency" [currency]="userCurrency" locale="en-US" [ngModelOptions]="{standalone: true}" />
                </td>
                <td style="width: 15%; text-align: center; white-space: nowrap; padding: 0 10px" rowspan="2">{{poManager.current.totalAdjusted | currency:poManager.current.currency:true}}</td>
            </tr>
            <tr class="bordered-row">
                <!-- <td [style.width]="columns[0].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.number}}</td> -->
                <td [style.width]="columns[1].widthPercent + '%'" [style.text-align]="'center'">Non-Ferrous</td>
                <td [style.width]="columns[2].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.numMiscellaneous}}</td>
                <td [style.width]="columns[3].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.totalMiscPrice | currency:poManager.current.currency:true}}</td>
                <td [style.width]="columns[5].widthPercent + '%'" [style.textAlign]="'center'" >                            
                    <p-inputNumber [inputStyle]="{'width': '100px', 'backgroundColor': 'white', 'border': '1px solid gray'}" [(ngModel)]="poManager.current.nonFerrousAdjustment" (ngModelChange)="poManager.adjustmentChange()" inputId="currency-us" mode="currency" [currency]="userCurrency" locale="en-US" [ngModelOptions]="{standalone: true}" />
                </td>
                <!-- <td [style.width]="columns[4].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.adjustment | currency:poManager.current.currency:true}}</td> -->
            </tr>
            </table>
            <ls-payment-types-selection style="width: 100%" [(selectedPaymentTypes)]="selectedPaymentTypes" />
        </div>
    </div>

    <div class="po-info">
        <div>9.</div>
        <div class="po-info-section">
            <div class="multi-signature-line tall signature">
                <div class="text">{{removeUnderscores(purchaserSignatureText)}}</div>
                <div class="signature-auto-expand"><ls-capture-signature #purchaserSignature></ls-capture-signature></div>
            </div>
        </div>
    </div>

    <div class="po-info">
        <div style="padding-top: 0">10.</div>
        <div class="po-info-section" [innerHTML]="section9Text"></div>
    </div>

    <div class="po-info">
        <div>11.</div>
        <div class="po-info-section">
            <div class="multi-signature-line tall signature">
                <div class="text">{{removeUnderscores(sellerSignatureText)}}</div>
                <div class="signature-auto-expand"><ls-capture-signature #sellerSignature></ls-capture-signature></div>
            </div>
        </div>
    </div>

    <div class="buttons">
        <div class="buttons-left">
            <p-button severity="secondary" (click)="clearSignatures()">Clear Signatures</p-button>
        </div>
        <div class="buttons-right">
            <p-button severity="secondary" (click)="onCancel()">Cancel</p-button>
            <!-- <p-button (click)="onSave()">Confirm</p-button> -->
            <p-button [disabled]="
                selectedTimezone == null || 
                !poManager.current.totalsValid || 
                sellerSignature.isEmpty || 
                purchaserSignature.isEmpty ||
                (poManager.current.additionalData?.sellerFullName?.length ?? 0) === 0 || 
                (poManager.current.additionalData?.homeAddress?.length ?? 0) === 0 || 
                (poManager.current.additionalData?.homeCountry?.length ?? 0) === 0 || 
                (poManager.current.additionalData?.homeZip?.length ?? 0) === 0 || 
                (poManager.current.additionalData?.homePhoneNumber?.length ?? 0) === 0"
                    (click)="onSave()">Confirm</p-button>
                <!-- sellersBusinessAddress.length === 0 || sellersBusinessCounty.length === 0 || sellersBusinessZip.length === 0 || sellersBusinessPhoneNumber.length === 0" -->
        </div>
    </div>
</form>
